export function newFornecedor() {
    return {
        nome_fantasia: '',
        razao_social: '',
        cnpj: '',
        company_id: 0,
    };
}
